import { Component, ContentChild, ElementRef, Input } from '@angular/core';
import { FcpInputComponent } from '../fcp-input/fcp-input.component';
import { FcpSelectComponent } from '../fcp-select';

@Component({
    selector: 'fcp-form-field',
    templateUrl: './fcp-form-field.component.html',
    styleUrls: ['./fcp-form-field.component.less'],
    standalone: false
})
export class FcpFormFieldComponent {
    @ContentChild(FcpInputComponent, { read: ElementRef }) public fcpInput;
    @ContentChild(FcpSelectComponent) fcpSelect: FcpSelectComponent | undefined;
    @Input() showErrorInline = false;
    @Input() isInvalid = false;
    @Input() width: WidthOptions = WidthOptions.Default;
    @Input() height: HeightOptions = HeightOptions.Default;
    @Input() compact = false;
}

export enum WidthOptions {
    Default = 'default',
    Fluid = 'fluid'
}

export enum HeightOptions {
    Default = 'default',
    Hug = 'hug'
}
